import { defineStore } from 'pinia';
import axios from 'axios';
import { useAuthStore } from './auth.store';
import { useNotificationsStore } from './notifications.store';

const apiBase = import.meta.env.VITE_API_URL;

export const useBillingStore = defineStore('billingStore', () => {
  const authStore = useAuthStore();
  const notificationsStore = useNotificationsStore();

  const createCheckoutSession = (deviceId: number): Promise<string> => {
    return new Promise((resolve, reject) => {
      axios<{ url: string }>({
        method: 'POST',
        url: `${apiBase}/billing/checkout-session`,
        headers: {
          Authorization: 'Bearer ' + authStore.idAuthToken,
        },
        data: { deviceId },
      })
        .then((result) => {
          if (result.data.url) {
            resolve(result.data.url);
          } else {
            reject(new Error('Missing checkout URL'));
          }
        })
        .catch((err) => {
          notificationsStore.error('Unable to start subscription checkout');
          reject(err);
        });
    });
  };

  const createPortalSession = (): Promise<string> => {
    return new Promise((resolve, reject) => {
      axios<{ url: string }>({
        method: 'POST',
        url: `${apiBase}/billing/portal-session`,
        headers: {
          Authorization: 'Bearer ' + authStore.idAuthToken,
        },
      })
        .then((result) => {
          if (result.data.url) {
            resolve(result.data.url);
          } else {
            reject(new Error('Missing portal URL'));
          }
        })
        .catch((err) => {
          notificationsStore.error('Unable to open billing portal');
          reject(err);
        });
    });
  };

  const subscribeToDevice = async (deviceId: number): Promise<void> => {
    const url = await createCheckoutSession(deviceId);
    window.location.href = url;
  };

  const openBillingPortal = async (): Promise<void> => {
    const url = await createPortalSession();
    window.location.href = url;
  };

  return {
    createCheckoutSession,
    createPortalSession,
    subscribeToDevice,
    openBillingPortal,
  };
});
